import React, { useState, useRef } from "react";
import { Modal, Button, Form, Row, Col } from "react-bootstrap";
import propertyImage from '../assets/images/confirm-tour-img.png';
import ConfirmTourIcon from '../assets/images/confirm-tour-icon.svg';
import ConfirmArrow from '../assets/images/confirm-arrow.svg';

function RequestTourModal({ main_image,show, handleClose, onNext, slots, street_address, beds, baths, size }) {

  const [selectedDateIndex, setSelectedDateIndex] = useState(null);
  const [selectedTime, setSelectedTime] = useState("");
  const [selectedSlotId, setSelectedSlotId] = useState("");
  const [error, setError] = useState("");

  const datesWrapperRef = useRef(null);

  const dates = slots || [];
  const times = selectedDateIndex !== null ? dates[selectedDateIndex].times : [];



  const handleNext = () => {
    if (onNext) {
      if (selectedSlotId == "") {
        setError("Please select a time slot")
      } else {
        setError("")
        onNext({ viewing_slot_id: selectedSlotId, });
      }

    }
  };

  const scrollLeft = () => {
    if (datesWrapperRef.current) {
      datesWrapperRef.current.scrollBy({
        left: -200,
        behavior: 'smooth'
      });
    }
  };

  const scrollRight = () => {
    if (datesWrapperRef.current) {
      datesWrapperRef.current.scrollBy({
        left: 200,
        behavior: 'smooth'
      });
    }
  };


  return (
    <Modal
      show={show}
      onHide={handleClose}
      centered
      scrollable
      className="tour-modal request-tour-modal"
      backdrop="static"
      keyboard={false}
    >
      <Modal.Header closeButton className="border-0">
        <Modal.Title>Confirm Your Tour</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {/* Property Info */}
        <div className="property-info-card">
          <Row className="align-items-center">
            <Col md={4}>
              <div className="property-thumbnail">
                <img src={main_image} alt="Property" className="w-100 rounded" />
              </div>
            </Col>
            <Col md={8}>
              <div className="property-details">
                <h6>{street_address}</h6>
                <p>
                  <span>{beds} bd</span>
                  <span className="dot"></span>
                  <span>{baths} ba</span>
                  <span className="dot"></span>
                  <span>{size} sq ft</span>
                </p>
              </div>
            </Col>
          </Row>
        </div>
        <div className="tour-description d-flex align-items-start">
          <img src={ConfirmTourIcon} alt="" />
          <p className="mb-0">
            Go on a personalized tour of this home by connecting with a local buyer's agent who advertises on Real Estate
          </p>
        </div>
        <div className="date-selection">
          <h6>Select Time</h6>
          <div className="date-carousel d-flex align-items-center">
            <Button variant="link" className="carousel-btn" onClick={scrollLeft}>
              <img src={ConfirmArrow} alt="" />
            </Button>

            <div className="dates-wrapper d-flex gap-3 flex-grow-1" ref={datesWrapperRef}>
              {dates.map((date, index) => (
                <div
                  key={index}
                  className={`date-card ${selectedDateIndex === index ? 'active' : ''}`}
                  onClick={() => {
                    setSelectedDateIndex(index);
                    setSelectedTime(""); // reset time when date changes
                  }}
                >
                  <div className="day">{date.day}</div>
                  <div className="date">{date.date}</div>
                </div>
              ))}
            </div>

            <Button variant="link" className="carousel-btn rotate-180" onClick={scrollRight}>
              <img src={ConfirmArrow} alt="" />
            </Button>
          </div>
        </div>
        <Form.Group className="mb-4">
          <Form.Select
            value={selectedSlotId}
            onChange={(e) => setSelectedSlotId(e.target.value)}
            className="form-select"
            required
            disabled={selectedDateIndex === null}
          >
            <option value="">Select a time</option>

            {times.map((time) => (
              <option key={time.id} value={time.id}>
                {time.time}
              </option>
            ))}
          </Form.Select>
        </Form.Group>

        <Button
          className="w-100 custom-bttn style-3  btn-next mb-3"
          onClick={handleNext}

        >
          Next
        </Button>

        <label className="text-danger">{error}</label>

        {/* Disclaimer */}
        <p className="disclaimer-text small text-muted mb-0">
          By pressing Contact an agent, you agree that Real Estate Group and its affiliates,
          and real estate professionals may call/text you about your inquiry, which may
          involve use of automated means and prerecorded/artificial voices. You don't
          need to consent as a condition of buying any property, goods or services.
          Message/data rates may apply. You also agree to our Terms of Use. Real Estate
          does not endorse any real estate professionals. We may share information about
          your recent and future site activity with your agent to help them understand what
          you're looking for in a home.
        </p>
      </Modal.Body>
    </Modal>
  );
}

export default RequestTourModal;